module.exports = __webpack_public_path__ + "static/img/language.c29ff206.svg";